<template>
  <svg v-bind="attributes"
       v-html="content">
  </svg>
</template>

<script>
export default {
  name: 'InlineSvg',

  props: {
    src: {
      type: String,
      required: true,
    },
    class: {
      type: String,
    },
  },

  data: () => ({
    element: null,
  }),

  computed: {
    attributes() {
      const attributes = {
        class: this.class,
      };

      if (this.element === null) {
        return attributes;
      }

      // eslint-disable-next-line
      for (let i = 0; i < this.element.attributes.length; i++) {
        const attribute = this.element.attributes.item(i);
        attributes[attribute.name] = attribute.value;
      }

      return attributes;
    },

    content() {
      const { element } = this;
      return element !== null ? element.innerHTML : null;
    },
  },

  watch: {
    src: {
      handler: 'getElement',
      immediate: true,
    },
  },

  methods: {
    getElement() {
      const path = this.src.replace('@', '/vue-modules/packages-overview/src');

      fetch(path)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const document = parser.parseFromString(html, 'text/html');
          this.element = document.querySelector('svg');

          if (this.element === null) {
            console.error(`No svg-element found in '${path}'`);
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
